export default __webpack_public_path__ + "static/media/Torpedo.e296f8c4.png";